/**
 * Reverse lookup: protective functions that touch one `:Equipment`
 * (`$equipmentId` param) as a sensor, final element, or protected asset.
 *
 * Returns one row per function with the distinct relationship types
 * (`SENSED_BY` / `ACTUATES` / `PROTECTS`) so the equipment detail page
 * can chip-link into Safety without draining the full Safety landing.
 *
 * Bounded by `LIMIT 200`.
 */
export const PLANT_EQUIPMENT_PROTECTIVE_FUNCTIONS_CYPHER = `
            MATCH (eq:Equipment {id: $equipmentId})
            OPTIONAL MATCH (pf:ProtectiveFunction)-[r:SENSED_BY|ACTUATES|PROTECTS]->(eq)
            WITH pf, collect(DISTINCT type(r)) AS roles
            WHERE pf IS NOT NULL
            RETURN pf AS function, roles
            ORDER BY pf.name ASC
            LIMIT 200
          `
